import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TierGrid from "../components/TierGrid";
import InvestmentModal from "../components/InvestmentModal";
import BotSubscriptionModal from "../components/BotSubscriptionModal";
import { useAuth } from "../lib/auth";
import { TIER_META } from "../lib/api";
import { useNavigate } from "react-router-dom";

const INVEST_BG = "https://images.unsplash.com/photo-1551033406-611cf9f6f7f5?auto=format&fit=crop&w=1600&q=80";

export default function InvestPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [tier, setTier] = useState(null);
  const [open, setOpen] = useState(false);
  const [botTier, setBotTier] = useState(null);
  const [botOpen, setBotOpen] = useState(false);
  const { user, refreshUser } = useAuth();
  const nav = useNavigate();

  const onSelect = (k) => {
    if (!user) {
      nav("/login");
      return;
    }
    setTier(k);
    setOpen(true);
  };

  const onSelectBot = (k) => {
    if (!user) {
      nav("/login");
      return;
    }
    setBotTier(k);
    setBotOpen(true);
  };

  const activeBot = user?.ai_bot_tier ? TIER_META[user.ai_bot_tier] : null;

  return (
    <div className="min-h-screen">
      <Navbar />
      <section className="relative max-w-7xl mx-auto px-6 py-20 overflow-hidden" data-testid="invest-page">
        <div className="absolute inset-0 -z-10">
          <img src={INVEST_BG} alt="Reviewing financial charts" className="w-full h-full object-cover opacity-20 brightness-90" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(rgba(10,14,39,0.85), rgba(10,14,39,0.85))" }} />
        </div>

        <div className="max-w-3xl mb-12">
          <div className="label-eyebrow">AI Bot Subscription</div>
          <h1 className="font-display text-5xl lg:text-6xl font-black mt-3 leading-tight">
            Activate the bot.<br /><span className="gold-grad">Then fund real capital.</span>
          </h1>
          <p className="text-white/70 mt-5 leading-relaxed">
            Duocapital now runs in two stages. First, subscribe to an AI Bot tier to set your ROI rate and unlock the trading terminal. Then choose a real investment tier for the capital the bot will trade.
          </p>
        </div>

        {!user || !user.ai_bot_active ? (
          <div>
            <div className="mb-6 text-white/70">
              {user?.ai_bot_pending
                ? "Your AI Bot subscription is pending admin approval. You'll be able to fund real capital once it's confirmed."
                : "Stage 1: choose your AI Bot subscription tier. This activates the bot and determines the ROI rate used for future real investments."}
            </div>
            <TierGrid onSelect={onSelectBot} mode="bot" />
          </div>
        ) : (
          <div>
            <div className="mb-6 text-white/70">
              Stage 2: your {activeBot?.name || user.ai_bot_tier} AI Bot is active at {activeBot?.roi || 0}% ROI. Choose a real investment tier to fund your portfolio.
            </div>
            <TierGrid onSelect={onSelect} mode="investment" />
          </div>
        )}
      </section>

      <InvestmentModal
        open={open}
        tier={tier}
        roiOverride={activeBot?.roi}
        onClose={() => setOpen(false)}
        onSuccess={() => nav("/dashboard")}
      />

      <BotSubscriptionModal
        open={botOpen}
        tier={botTier}
        onClose={() => setBotOpen(false)}
        onSuccess={async () => {
          await refreshUser();
          nav("/dashboard");
        }}
      />

      <Footer />
    </div>
  );
}